module.exports = __webpack_public_path__ + "img/goodreadsdata.826505ca.png";